<div class="app-sidebar bg-royal sidebar-shadow sidebar-text-light scroll-menu">
    <!-- <div class="app-header__logo">
        <div class="header__pane ml-auto">
            <div>
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
                    data-class="closed-sidebar">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="app-header__mobile-menu">
        <div>
            <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
    </div> -->
    <div class="app-header__menu">
        <span>
            <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
                <span class="btn-icon-wrapper">
                    <i class="fa fa-ellipsis-v fa-w-6"></i>
                </span>
            </button>
        </span>
    </div>
    <div class="scrollbar-sidebar">
        <div class="app-sidebar__inner">
            <ul class="vertical-nav-menu">
                <li class="app-sidebar__heading">{{'data.analysis' | translate }}</li>
                <li>
                    <a routerLink="" routerLinkActive="mm-active" [routerLinkActiveOptions]="{exact: true}"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-graph2"></i>
                        {{'data.dashboard' | translate }}
                    </a>
                    <a routerLink="/search" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-search"></i>
                        {{'data.search' | translate }}
                    </a>
                    <a [routerLink]="['/all-commandes']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-photo-gallery"></i>
                        {{'data.All_orders' | translate}}
                    </a>
                    <a [routerLink]="['/all-trailers']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-plane"></i>
                        {{'data.All_trailers' | translate}}
                    </a>
                </li>
                <li class="app-sidebar__heading" *ngIf="idSociety==null">Sociétés</li>
                <li *ngIf="idSociety==null">
                    <a [routerLink]="['/society-cof']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-culture"></i>
                        Ajouter société
                    </a>
                    <a [routerLink]="['/all-societies-cof']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-photo-gallery"></i>
                        Liste des sociétés
                    </a>

                </li>
                <li class="app-sidebar__heading">{{'data.providers' | translate}}</li>
                <li>
                    <a [routerLink]="['/add-provider']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-user"></i>
                        {{'data.add_provider' | translate}}
                    </a>
                    <a [routerLink]="['/providers']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-users"></i>
                        {{'data.providers' | translate}}
                    </a>
                    <a [routerLink]="['/add-commande']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-box2"></i>
                        {{'data.add_pickup' | translate }}
                    </a>
                    <!-- <a [routerLink]="['/account-provider']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-users"></i>
                        Compte fournisseur
                    </a> -->
                    <!-- <a [routerLink]="['/demande-client']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-users"></i>
                        Demandes clients
                    </a> -->
                </li>
                <li class="app-sidebar__heading">{{'data.Transport_companies' | translate}}</li>
                <li>
                    <a [routerLink]="['/society-transportors']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-culture"></i>
                        {{'data.company' | translate}}
                    </a>
                    <a [routerLink]="['/business-accounts']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-diamond"></i>
                        {{'data.Business_account' | translate}}
                    </a>
                </li>

                <li class="app-sidebar__heading space-top">{{'data.settings' | translate }}</li>
                <li>
                    <!-- <a routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-settings"></i>
                        Paramètre de conditionnement
                    </a> -->
                    <a [routerLink]="['/all-products']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-box2"></i>
                        {{'data.boxes' | translate }}
                    </a>
                    <a [routerLink]="['/all-pallets']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-cart"></i>
                        {{'data.pallets' | translate }}
                    </a>
                </li>
                <!-- <li class="app-sidebar__heading">Gestion des retours</li>
                <li>
                    <a [routerLink]="['/invalid-return']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-back-2"></i>
                        Retours invalides
                    </a>
                    <a [routerLink]="['/valid-return']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-shuffle"></i>
                        Retours validés
                    </a>
                </li> -->
                <!-- <li class="app-sidebar__heading">Voyages</li>
                <li>
                    <a [routerLink]="['/trips']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-magic-wand"></i>
                        Réservation
                    </a>
                </li> -->
                <!-- <li class="app-sidebar__heading">Sacs</li>
                <li>
                    <a [routerLink]="['/add-sac']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-box2"></i>
                        Ajouter sac
                    </a>
                    <a [routerLink]="['/sacs']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-box1"></i>
                        Sacs
                    </a>
                    <a [routerLink]="['/villes']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-map-2"></i>
                        Villes
                    </a>
                </li> -->
                <!-- <li class="app-sidebar__heading">Statistiques</li>
                <li>
                    <a [routerLink]="['/details-virements']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-cash"></i>
                        Détail virements
                    </a>
                    <a [routerLink]="['/virements-clients']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-display2"></i>
                        Virements fournisseur
                    </a>
                    <a [routerLink]="['/statistics']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-server"></i>
                        Statistiques
                    </a>
                </li> -->
                <li class="app-sidebar__heading" *ngIf="isAdmin">{{'data.users' | translate}}</li>
                <li *ngIf="isAdmin">
                    <!-- <a [routerLink]="['/travelers']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-users"></i>
                        Liste des voyageurs
                    </a> -->
                    <a [routerLink]="['/add-team']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-add-user"></i>
                        {{'data.add_user' | translate}}
                    </a>
                    <a [routerLink]="['/all-teams']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-id"></i>
                        {{'data.users' | translate}}
                    </a>
                    <!-- <a [routerLink]="['/preparers']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-tools"></i>
                        Preparateurs
                    </a>
                    <a [routerLink]="['/tracking-user']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-car"></i>
                        Transporteurs
                    </a> -->
                    <!-- <a [routerLink]="['/louagistes']" routerLinkActive="mm-active" (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-car"></i>
                        Louagistes
                    </a> -->
                    <!-- <a [routerLink]="['/statistics-tranportor']" routerLinkActive="mm-active"
                        (click)="closeToggleSidebarMobile()">
                        <i class="metismenu-icon pe-7s-car"></i>
                        Statistiques des Transporteurs
                    </a> -->
                    <!-- <a href="#">
                        <i class="metismenu-icon pe-7s-home"></i>
                        Point de collectes
                    </a>
                    <a href="#">
                        <i class="metismenu-icon pe-7s-home"></i>
                        Point de collectes
                    </a>
                    <a href="#">
                        <i class="metismenu-icon pe-7s-home"></i>
                        Point de collectes
                    </a>
                    <a href="#">
                        <i class="metismenu-icon pe-7s-home"></i>
                        Point de collectes
                    </a>
                    <a href="#">
                        <i class="metismenu-icon pe-7s-home"></i>
                        Point de collectes
                    </a> -->
                </li>

                <!-- <li class="app-sidebar__heading space-top">Reclamations</li>
                <li>
                    <a class="font-menu">
                        <i class="metismenu-icon pe-7s-headphones"></i>
                        Mes reclamations
                    </a>
                </li> -->
                <!-- <li class="app-sidebar__heading">UI Components</li>
                <li>
                    <a href="#">
                        <i class="metismenu-icon pe-7s-diamond"></i>
                        Elements
                        <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
                    </a>
                    <ul>
                        <li>
                            <a href="elements-buttons-standard.html">
                                <i class="metismenu-icon"></i>
                                Buttons
                            </a>
                        </li>
                        <li>
                            <a href="elements-dropdowns.html">
                                <i class="metismenu-icon">
                                </i>Dropdowns
                            </a>
                        </li>
                        <li>
                            <a href="elements-icons.html">
                                <i class="metismenu-icon">
                                </i>Icons
                            </a>
                        </li>
                        <li>
                            <a href="elements-badges-labels.html">
                                <i class="metismenu-icon">
                                </i>Badges
                            </a>
                        </li>
                        <li>
                            <a href="elements-cards.html">
                                <i class="metismenu-icon">
                                </i>Cards
                            </a>
                        </li>
                        <li>
                            <a href="elements-list-group.html">
                                <i class="metismenu-icon">
                                </i>List Groups
                            </a>
                        </li>
                        <li>
                            <a href="elements-navigation.html">
                                <i class="metismenu-icon">
                                </i>Navigation Menus
                            </a>
                        </li>
                        <li>
                            <a href="elements-utilities.html">
                                <i class="metismenu-icon">
                                </i>Utilities
                            </a>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="#">
                        <i class="metismenu-icon pe-7s-car"></i>
                        Components
                        <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
                    </a>
                    <ul>
                        <li>
                            <a href="components-tabs.html">
                                <i class="metismenu-icon">
                                </i>Tabs
                            </a>
                        </li>
                        <li>
                            <a href="components-accordions.html">
                                <i class="metismenu-icon">
                                </i>Accordions
                            </a>
                        </li>
                        <li>
                            <a href="components-notifications.html">
                                <i class="metismenu-icon">
                                </i>Notifications
                            </a>
                        </li>
                        <li>
                            <a href="components-modals.html">
                                <i class="metismenu-icon">
                                </i>Modals
                            </a>
                        </li>
                        <li>
                            <a href="components-progress-bar.html">
                                <i class="metismenu-icon">
                                </i>Progress Bar
                            </a>
                        </li>
                        <li>
                            <a href="components-tooltips-popovers.html">
                                <i class="metismenu-icon">
                                </i>Tooltips &amp; Popovers
                            </a>
                        </li>
                        <li>
                            <a href="components-carousel.html">
                                <i class="metismenu-icon">
                                </i>Carousel
                            </a>
                        </li>
                        <li>
                            <a href="components-calendar.html">
                                <i class="metismenu-icon">
                                </i>Calendar
                            </a>
                        </li>
                        <li>
                            <a href="components-pagination.html">
                                <i class="metismenu-icon">
                                </i>Pagination
                            </a>
                        </li>
                        <li>
                            <a href="components-scrollable-elements.html">
                                <i class="metismenu-icon">
                                </i>Scrollable
                            </a>
                        </li>
                        <li>
                            <a href="components-maps.html">
                                <i class="metismenu-icon">
                                </i>Maps
                            </a>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="tables-regular.html">
                        <i class="metismenu-icon pe-7s-display2"></i>
                        Tables
                    </a>
                </li>
                <li class="app-sidebar__heading">Widgets</li>
                <li>
                    <a href="dashboard-boxes.html">
                        <i class="metismenu-icon pe-7s-display2"></i>
                        Dashboard Boxes
                    </a>
                </li>
                <li class="app-sidebar__heading">Forms</li>
                <li>
                    <a href="forms-controls.html">
                        <i class="metismenu-icon pe-7s-mouse">
                        </i>Forms Controls
                    </a>
                </li>
                <li>
                    <a href="forms-layouts.html">
                        <i class="metismenu-icon pe-7s-eyedropper">
                        </i>Forms Layouts
                    </a>
                </li>
                <li>
                    <a href="forms-validation.html">
                        <i class="metismenu-icon pe-7s-pendrive">
                        </i>Forms Validation
                    </a>
                </li>
                <li class="app-sidebar__heading">Charts</li>
                <li>
                    <a href="charts-chartjs.html">
                        <i class="metismenu-icon pe-7s-graph2">
                        </i>ChartJS
                    </a>
                </li>
                <li class="app-sidebar__heading">PRO Version</li>
                <li>
                    <a href="https://dashboardpack.com/theme-details/architectui-dashboard-html-pro/"
                        target="_blank">
                        <i class="metismenu-icon pe-7s-graph2">
                        </i>
                        Upgrade to PRO
                    </a>
                </li> -->
            </ul>
        </div>
        <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
            <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
        </div>
        <div class="ps__rail-y" style="top: 0px; height: 662px; right: 0px;">
            <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 472px;"></div>
        </div>
    </div>
    <div class="app-sidebar-bg"></div>
</div>